import { IdData, IsActiveNoTimestampData } from "./Types"

export type EquipmentDataUnion = AirMoverData | AirScrubberData | DehumidifierData | FloorDryingSystemData | HeaterData

export interface Manufacturer extends IdData<ManufacturerData> {
}

export interface ManufacturerData extends IsActiveNoTimestampData {
    name: string
    nameLower: string
}

export enum EquipmentType {
    AirMover = 'AirMover',
    AirScrubber = 'AirScrubber',
    Dehumidifier = 'Dehumidifier',
    FloorDryingSystem = 'FloorDryingSystem',
    Heater = 'Heater',
}

export interface EquipmentManufacturerData {
    id: string
    name: string
    nameLower: string
}

export interface Equipment extends IdData<EquipmentData> {
}

export interface EquipmentData extends IsActiveNoTimestampData {
    equipmentType: EquipmentType
    manufacturer: EquipmentManufacturerData
    model: string
    modelLower: string
}

export interface ElectricalData {
    amps: number
    volts: number
}

export interface ElectricalEquipmentData extends EquipmentData, ElectricalData {
}

export enum AirMoverType {
    Axial = 'Axial',
    Centrifugal = 'Centrifugal',
    RadialOrLowProfile = 'RadialOrLowProfile',
}

export interface AirMover extends IdData<AirMoverData> {
}

export interface AirMoverData extends ElectricalEquipmentData {
    airMoverType: AirMoverType
    canCalcRoomCounts: boolean          // true if this type can be used for Air Mover Room Counts calculation
    calcRoomCountsType?: AirMoverType   // optional different type to use for calculating room counts
}

export interface AirScrubberSettingData extends ElectricalData {
    cfm: number
    settingsCount: number
    settingsIndex: number
}

export interface AirScrubber extends IdData<AirScrubberData> {
}

export interface AirScrubberData extends EquipmentData {
    settings: AirScrubberSettingData[]
}

export enum DehumidifierType {
    Conventional = 'Conventional',
    Lgr = 'Lgr',
    Desiccant = 'Desiccant',
}

export interface Dehumidifier extends IdData<DehumidifierData> {
}

export interface DehumidifierData extends ElectricalEquipmentData {
    dehumidifierType: DehumidifierType
    pints: number
}

export interface FloorDryingSystem extends IdData<FloorDryingSystemData> {
}

export interface FloorDryingSystemData extends ElectricalEquipmentData {
    maxAreaPerUnitForPreFinishedFt2: number
    maxAreaPerUnitForSandedAndFinishedFt2: number
    maxPanelsForPreFinished: number
    maxPanelsForSandedAndFinished: number
}

export interface HeaterSettingData extends ElectricalData {
    cfm: number
    totalBtuPerHour: number
    settingsCount: number
    settingsIndex: number
}

export interface Heater extends IdData<HeaterData> {
}

export interface HeaterData extends EquipmentData {
    settings: HeaterSettingData[]
}